import { render, staticRenderFns } from "./FormRecord.vue?vue&type=template&id=5aec08ea&scoped=true&"
import script from "./FormRecord.vue?vue&type=script&lang=ts&"
export * from "./FormRecord.vue?vue&type=script&lang=ts&"
import style0 from "./FormRecord.vue?vue&type=style&index=0&id=5aec08ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec08ea",
  null
  
)

export default component.exports